import React from "react";
import { Row, Col, Button } from "antd";
import { getCommodityIconSrc, getEcoOrGasNewPlansName } from "../../common";
import { PlanDetailsProps } from "../../types/planType";
import { btnStyle } from "../../cro/styles/buttonStyles";
import { useModal } from "../../cro/context/CroModalContext";
import CroModalCloseBtn from "../../cro/context/CroModalCloseBtn";
import OpenInNew from "../../cro/icons/OpenInNew.svg";
import { useTranslation } from "react-i18next";

const titleStyle = {
  margin: "1rem 0",
};

const PlanDetails: React.FC<PlanDetailsProps> = ({
  plan,
  selectPlan,
  utilityId,
  isTx,
  isPa,
  userZipCode,
  isFeatured,
  isTypeVariable,
  filteredMonthlyEstData,
  utilityName,
}) => {
  const { hideModal } = useModal();
  const { t } = useTranslation("cro");

  return (
    <div style={{ padding: 16, width: "100%", color: "#253F66" }}>
      <Row gutter={[16, 16]} align={"top"} justify={"center"}>
        <Col
          xs={24}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "#253F66",
            marginTop: "-1rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              gap: 8,
            }}
          >
            {Boolean(getEcoOrGasNewPlansName(plan.plan_name, utilityName)) ? (
              <div className="renewable_type me-2">
                <img
                  src={getCommodityIconSrc(
                    getEcoOrGasNewPlansName(plan.plan_name, utilityName)
                  )}
                  alt={plan.commodity_clean_name}
                  style={{ width: 35, height: 35 }}
                />
              </div>
            ) : plan.commodity_clean_name ? (
              <div className="renewable_type me-2">
                <img
                  src={getCommodityIconSrc(plan.commodity_clean_name)}
                  alt={plan.commodity_clean_name}
                  style={{ width: 35, height: 35 }}
                />
              </div>
            ) : (
              plan.plan_name.toLowerCase().includes("easy") && (
                <div className="renewable_type me-2">
                  <img
                    src={getCommodityIconSrc("easy")}
                    alt={plan.commodity_clean_name}
                    style={{ width: 35, height: 35 }}
                  />
                </div>
              )
            )}
            <p
              style={{
                fontSize: 20,
                fontWeight: "bold",
                margin: "0 1rem",
                width: "100%",
                color: "#253F66",
              }}
            >
              {plan.plan_name}
            </p>
          </div>
          <CroModalCloseBtn />
        </Col>
        <Col xs={24}>
          {/* <p
            style={{
              color: "253f66",
            }}
          >
            {isFeatured ? plan.ef_plan_details?.callout_text : plan.plan_desc}
          </p> */}
          {plan.ef_plan_details?.plan_descriptions &&
          plan.ef_plan_details?.plan_descriptions["Plan Description"] ? (
            <>
              <span>
                {plan.ef_plan_details?.plan_descriptions &&
                  plan.ef_plan_details?.plan_descriptions["Plan Description"]}
              </span>
              {plan.ef_plan_details?.plan_descriptions &&
                plan.ef_plan_details?.plan_descriptions["Disclaimer"] && (
                  <>
                    <br />
                    <span style={{ fontSize: "0.75rem" }}>
                      {plan.ef_plan_details?.plan_descriptions &&
                        plan.ef_plan_details?.plan_descriptions["Disclaimer"]}
                    </span>
                  </>
                )}
            </>
          ) : (
            <p
              style={{
                color: "#253F66",
                fontSize: 14,
                fontWeight: 400,
                marginTop: 8,
              }}
              dangerouslySetInnerHTML={{
                __html: isFeatured
                  ? plan.ef_plan_details?.callout_text || ""
                  : plan.plan_desc || "",
              }}
            ></p>
          )}
        </Col>
        {filteredMonthlyEstData.length > 0 && (
          <Col xs={24} sm={24} md={14}>
            <div style={titleStyle}>{t("ESTIMATED MONTHLY SAVINGS")}</div>
            <div
              style={{
                padding: ".75rem",
                margin: 0,
                border: "1px solid #E2E8F0",
                borderRadius: 12,
              }}
            >
              <Row align={"middle"} justify={"center"} gutter={[32, 32]}>
                <Col span={8} style={{ fontWeight: "500" }}>
                  <span>{t("HOME SIZE")}</span>
                </Col>
                <Col span={8} style={{ fontWeight: "500" }}>
                  <span>{t("AVERAGE PRICE PER KWH")}</span>
                </Col>
                <Col span={8} style={{ fontWeight: "500" }}>
                  <span>{t("ESTIMATED MONTHLY SAVINGS")}</span>
                </Col>
              </Row>
              {filteredMonthlyEstData?.map((data) => (
                <Row
                  key={data.key}
                  align={"middle"}
                  justify={"center"}
                  gutter={[32, 32]}
                  className="roboto-regular"
                >
                  <Col span={8} style={{ fontWeight: 400, margin: ".25rem 0" }}>
                    {data.homeSize}
                  </Col>
                  <Col span={8} style={{ margin: ".25rem 0" }}>
                    {data.avgPrice}
                  </Col>
                  <Col span={8} style={{ margin: ".25rem 0" }}>
                    {data.monthlySavings}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
        )}
        <Col xs={24} sm={24} md={filteredMonthlyEstData.length > 0 ? 10 : 24}>
          <Row>
            <Col span={24} style={{ color: "#253F66" }}>
              <div style={titleStyle}>{t("Documents")}</div>
              <ul style={{ marginTop: 8 }}>
                {plan.docs.map((doc: any, index: number) => (
                  <li key={index} style={{ marginBottom: "10px" }}>
                    <img
                      src={OpenInNew}
                      alt="open in new tab"
                      style={{
                        width: "1.5rem",
                        height: "auto",
                        marginRight: 8,
                      }}
                    />
                    <a
                      href={doc.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        color: "#253F66",
                        fontWeight: 400,
                      }}
                    >
                      {t(doc.display_name.trim())}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: 16,
              gap: 16,
            }}
          >
            <Button style={btnStyle} onClick={selectPlan}>
              {t("Select Plan")}
            </Button>
            <Button style={btnStyle} onClick={() => hideModal()}>
              {t("Close")}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PlanDetails;
